import { connect } from "react-redux";
import UpdatedTimeSheet from "./UpdatedTimeSheet";

import { getSPParticipantsListRequest, spRosteringSettingsRequest } from "store/actions/sp.actions";
import { getParticipantsList, getSpRosteringSetting, getSpRosteringSettingLoader } from "store/selector/sp.selector";
import { fetchTimesheetOfWorkers, resetSelectedTimesheetDateRange, resetUpdatedTimesheetPage, selectedTimesheetDateRange } from "store/actions/rostering.actions";
import { getTimesheetsofWorkers } from "store/selector/rostering.selector";

const mapDispatchToProps = {
  getParticipantList: getSPParticipantsListRequest,
  getTimesheetsofWorkers:fetchTimesheetOfWorkers,
  selectedTimesheetDateRange,
  resetDateRange:resetSelectedTimesheetDateRange,
  resetUpdatedTimesheetPage,
  spRosteringSettingsRequest
};

const mapStateToProps = (state) => {
  const spParticipants = getParticipantsList(state);
  const timeSheetsListOfWorkers = getTimesheetsofWorkers(state)
   const spRosteringSetting = getSpRosteringSetting(state);
   const spRosteringSettingLoader=getSpRosteringSettingLoader(state)
  return {
    spParticipants,
    timeSheetsListOfWorkers,
    spRosteringSetting,
    spRosteringSettingLoader
    
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdatedTimeSheet);
